function ArrowDownIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic_open_sm">
        <path
          id="Vector 96"
          d="M2 5L8 11L14 5"
          stroke="#9E9E9E"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default ArrowDownIcon;
